import { WMSLayer } from './WMSLayer';

const getTdtUrls = url => {
    return new Array(7).fill(0).map((_, i) => url.replace('{s}', i));
};

export default function () {
    return [
        new WMSLayer({
            data: getTdtUrls(
                'https://t{s}.tianditu.gov.cn/vec_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=vec&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk=f17f2d0ddd4f1e2488d13dca42746bb9'
            ),
            minZoom: 1,
            maxZoom: 17,
            tileSize: 256,
            id: 'vec',
        }),
        new WMSLayer({
            data: getTdtUrls(
                'https://t{s}.tianditu.gov.cn/cva_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=cva&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk=f17f2d0ddd4f1e2488d13dca42746bb9'
            ),
            minZoom: 1,
            maxZoom: 17,
            tileSize: 256,
            id: 'cva',
        }),
    ];
}
